let refreshPromise = null;

export function getRefreshPromise() {
  return refreshPromise;
}

export function setRefreshPromise(promise) {
  refreshPromise = promise;
}

/** Annule un refresh en vol (évite qu'un ancien jeton écrase la nouvelle session après login). */
export function resetAuthRefreshState() {
  refreshPromise = null;
}